export const baseWords_by = {
    btns: {
        stand3D: 'Перайсці на 3D стэнд'
    },
    errorText: {
        message: 'Невядомая памылка'
    }
}